import React, { useRef, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { FiSettings } from 'react-icons/fi'
import { change, FieldArray } from 'redux-form'
import Flex from 'typescript-styled-flex'
import { isEmpty } from 'lodash'
import { connect } from 'react-redux'
import ExpandableFormSection, {
  StyledSection,
} from '../../../components/Form/Sections/ExpandableFormSection'
import { FormGroup, TextInput } from '../../../components/FormBuilder'
import CountrySelect from '../../../components/FormBuilder/CountrySelect'
import { Desktop } from '../../../components/MediaQuery'
import Button from '../../../components/Template/Button'
import { IEvent } from '../../../models/Event'
import { withSize } from '../../../hooks/useSize'
import { IWithSize } from '../../BookingCalendar/Calendar/Calendar'
import { ICreateReservationFormValues } from './CreateReservation'
import { GuestInfoCreate, GuestInfoUpdate } from './GuestInfo'
import {
  CallButtonCreate,
  CallButtonUpdate,
  MessageSendButtonCreate,
  MessageSendButtonUpdate,
  TemplateSendButtonCreate,
  TemplateSendButtonUpdate,
} from './TemplateSendButton'
import VisibilityControlled from './Components/VisibilityControlled'
import { ReservationFormFieldVisibility } from './withReduxForm'
import { withIsDesktop } from './withIsDesktop'

class GuestsTab extends React.Component<any, { phone: string }> {
  constructor(props) {
    super(props)
    this.state = {
      phone: this.props.initialValues.guest.phone,
    }
  }

  public shouldComponentUpdate(
    nextProps: Readonly<IGuestsTabProps & IWithSize>,
    nextState: Readonly<{ phone: string }>,
  ): boolean {
    return (
      nextProps.isSaving !== this.props.isSaving ||
      nextProps.type !== this.props.type ||
      nextProps.hideUserData !== this.props.hideUserData ||
      nextProps.isDesktop !== this.props.isDesktop ||
      nextProps.phoneError !== this.props.phoneError ||
      nextProps.allowTemplates !== this.props.allowTemplates ||
      nextState.phone !== this.state.phone ||
      nextProps.size !== this.props.size
    )
  }

  public setPhone = value => {
    if (/^[\d +]*$/g.test(value.target.value)) {
      this.setState(state => ({ ...state, phone: value.target.value }))
    }
    if (value) {
      this.props.setPhoneError(false)
    } else {
      this.props.setPhoneError(true)
    }
  }

  public verifyPhone = cb => {
    if (isEmpty(this.state.phone) || !/^[\d +]*$/g.test(this.state.phone)) {
      this.props.setPhoneError(true)
    } else {
      if (cb && typeof cb === 'function') {
        if (!this.props.isSaving) {
          cb()
        }
      }
    }
  }

  public normalizePhone = (val, prev) => {
    return /^[\d +]*$/g.test(val) ? val.substr(0, 25) : prev
  }

  public normalizeEmail = val => {
    return val.replace(/\s+/g, '')
  }

  public parseClient = (e, val, _, name) => {
    e.preventDefault()
    this.props.updateGuestName(
      this.props.type === 'create'
        ? 'create_reservation'
        : 'update_reservation',
      name,
      val
        ? val
            .split(' ')
            .map(s => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ')
        : '',
    )
  }

  public render(): React.ReactNode {
    const {
      t,
      type,
      isDesktop,
      size,
      phoneError,
      allowTemplates,
      firePricingError,
      hideUserData,
      isLite,
    } = this.props

    function redirect() {
      if (allowTemplates) {
        window.open(`/templates`, '_blank')
      } else {
        firePricingError()
      }
    }

    return (
      <Flex
        row={isDesktop}
        column={!isDesktop}
        full={true}
        style={{
          height: 'auto',
          padding: isDesktop
            ? `${10 * size}px ${16 * size}px ${25 * size}px ${16 * size}px`
            : `${10 * size}px ${20 * size}px ${16 * size}px`,
        }}
      >
        <Flex column={true} full={true}>
          <FormGroup.Render
            size={size}
            column={true}
            title={t('z677_main_guest')}
          >
            <Flex column={true}>
              {type === 'update' ? (
                <GuestInfoUpdate
                  disabled={hideUserData}
                  guestScroll={this.props.guestScroll}
                  setPhone={this.setPhone}
                  enableSearch={true}
                  size={size}
                  formKey={'guest'}
                  expanded={false}
                  guestLabel={t('z677_main_guest')}
                  parseName={this.parseClient}
                />
              ) : (
                <GuestInfoCreate
                  disabled={hideUserData}
                  guestScroll={this.props.guestScroll}
                  setPhone={this.setPhone}
                  enableSearch={true}
                  size={size}
                  formKey={'guest'}
                  expanded={false}
                  guestLabel={t('z677_main_guest')}
                  parseName={this.parseClient}
                />
              )}
              <Flex row={true}>
                <Flex style={{ width: '100%' }} column={true}>
                  <Flex alignStart style={{ width: '100%' }} row={true}>
                    <TextInput.ReduxField
                      size={size}
                      disabled={hideUserData}
                      label={t('reservation_phone')}
                      width={'100%'}
                      name={`guest.phone`}
                      normalize={this.normalizePhone}
                      onChange={this.setPhone}
                      errorMsg={
                        phoneError
                          ? t('reservation_dialing_number_parse_error')
                          : undefined
                      }
                      type={'text'}
                      isSmallReservation={true}
                      wrapperStyle={{ marginBottom: `${10 * size}px` }}
                      style={{
                        borderBottomRightRadius: 0,
                        borderTopRightRadius: 0,
                      }}
                    />
                    <Flex style={{ marginTop: `${34 * size}px` }}>
                      {type === 'update' ? (
                        <CallButtonUpdate
                          className={`reservation-form-call-phone-button`}
                          size={size}
                          onClick={this.verifyPhone}
                        />
                      ) : (
                        <CallButtonCreate
                          className={`reservation-form-call-phone-button`}
                          size={size}
                          onClick={this.verifyPhone}
                        />
                      )}
                    </Flex>
                    <Flex style={{ marginTop: `${34 * size}px` }}>
                      {type === 'update' ? (
                        <MessageSendButtonUpdate
                          className={`reservation-form-send-phone-button`}
                          size={size}
                          onClick={this.verifyPhone}
                        />
                      ) : (
                        <MessageSendButtonCreate
                          className={`reservation-form-send-phone-button`}
                          size={size}
                          onClick={this.verifyPhone}
                        />
                      )}
                    </Flex>
                  </Flex>
                  <VisibilityControlled field={'email'}>
                    <Flex alignStart style={{ width: '100%' }} row={true}>
                      <TextInput.ReduxField
                        label={t('email')}
                        disabled={hideUserData}
                        size={size}
                        width={'100%'}
                        name={`guest.email`}
                        normalize={this.normalizeEmail}
                        isSmallReservation={true}
                        style={{
                          borderBottomRightRadius: 0,
                          borderTopRightRadius: 0,
                        }}
                      />
                      <Flex style={{ marginTop: `${34 * size}px` }}>
                        {type === 'update' ? (
                          <TemplateSendButtonUpdate
                            className={`reservation-form-send-email-button`}
                            size={size}
                            isSaving={this.props.isSaving}
                          />
                        ) : (
                          <TemplateSendButtonCreate
                            className={`reservation-form-send-email-button`}
                            size={size}
                            isSaving={this.props.isSaving}
                          />
                        )}
                      </Flex>
                      <Flex style={{ marginTop: `${34 * size}px` }} alignEnd>
                        <Button
                          onClick={redirect}
                          light
                          data-cy={'reservation-form-settings-button'}
                          size={size}
                          style={{ borderRadius: 0, height: `${38 * size}px` }}
                        >
                          <FiSettings />
                        </Button>
                      </Flex>
                    </Flex>
                  </VisibilityControlled>
                </Flex>
              </Flex>
            </Flex>
          </FormGroup.Render>
        </Flex>
        <Desktop>
          <Flex
            style={{ flexBasis: `${25 * size}px`, minWidth: `${25 * size}px` }}
          />
        </Desktop>
        <Flex column={true} full={true}>
          <VisibilityControlled field={'additionalGuests'}>
            <FormGroup.Render
              size={size}
              column={true}
              isDisabled={isLite}
              withPopoverIcon={isLite}
              title={t('z677_additional_guests')}
            >
              <Flex column={true}>
                <GuestArray
                  size={size}
                  disabled={isLite}
                  isSaving={this.props.isSaving}
                  initial={this.props.initialValues}
                  parseName={this.parseClient}
                  type={type}
                  t={t}
                />
              </Flex>
            </FormGroup.Render>
          </VisibilityControlled>
        </Flex>
        <Desktop>
          <Flex
            style={{ flexBasis: `${25 * size}px`, minWidth: `${25 * size}px` }}
          />
        </Desktop>
        <Flex column={true} full={true}>
          <VisibilityControlled field={'company'}>
            <FormGroup.Render
              size={size}
              column={true}
              title={t('reservation_company_name')}
              isDisabled={isLite}
              withPopoverIcon={isLite}
            >
              <Flex column={true} full={true}>
                <ExpandableFormSection
                  size={size}
                  expanded={isLite}
                  withBorder={false}
                  initialInput={
                    <TextInput.ReduxField
                      disabled={isLite}
                      withPopoverIcon={isLite}
                      size={size}
                      name={`company.name`}
                      placeholder={t('reservation_company_name_hint')}
                      width={'100%'}
                      isSmallReservation={true}
                    />
                  }
                >
                  <Flex column={true} full={true}>
                    <TextInput.ReduxField
                      size={size}
                      disabled={isLite}
                      withPopoverIcon={isLite}
                      labelStyle={{display: 'flex',gap: '8px'}}
                      label={t('reservation_person_street')}
                      name={`company.street`}
                      width={'100%'}
                      isSmallReservation={true}
                      wrapperStyle={{ marginBottom: '10px' }}
                    />
                    <TextInput.ReduxField
                      size={size}
                      disabled={isLite}
                      withPopoverIcon={isLite}
                      labelStyle={{display: 'flex',gap: '8px'}}
                      label={t('reservation_person_town')}
                      width={'100%'}
                      name={`company.city`}
                      wrapperStyle={{ marginBottom: '10px' }}
                      isSmallReservation={true}
                    />
                    <TextInput.ReduxField
                      size={size}
                      disabled={isLite}
                      withPopoverIcon={isLite}
                      labelStyle={{display: 'flex',gap: '8px'}}
                      label={t('reservation_person_post_code')}
                      width={'100%'}
                      name={`company.postCode`}
                      wrapperStyle={{ marginBottom: '10px' }}
                      isSmallReservation={true}
                    />
                    <CountrySelect
                      size={size}
                      disabled={isLite}
                      withPopoverIcon={isLite}
                      labelStyle={{display: 'flex',gap: '8px'}}
                      name={`company.country`}
                      label={t('profile_country')}
                      width={'100%'}
                      noOptionsMessage={t('search_not_found')}
                      placeholder={t('select')}
                      isSearchable={true}
                      wrapperStyle={{ marginBottom: '10px' }}
                      isSmallReservation={true}
                      countryValue={'code'}
                      menuPlacement={'auto'}
                    />
                    <TextInput.ReduxField
                      size={size}
                      disabled={isLite}
                      withPopoverIcon={isLite}
                      labelStyle={{display: 'flex',gap: '8px'}}
                      label={t('profile_vat_number')}
                      width={'100%'}
                      name={`company.vatId`}
                      isSmallReservation={true}
                    />
                  </Flex>
                </ExpandableFormSection>
              </Flex>
            </FormGroup.Render>
          </VisibilityControlled>
        </Flex>
      </Flex>
    )
  }
}

const GuestArray = React.memo(
  ({ type, disabled, isSaving, t, size, parseName, initial }: any) => {
    const [phoneError, setPhoneError] = useState(Array.from(new Array(16)))
    const phone = useRef(
      initial.additionalGuests
        ? initial.additionalGuests.map(a => a.phone)
        : [],
    )

    const setPhone = i => p => {
      if (p.currentTarget.value && phoneError[i]) {
        const errors = [...phoneError]
        errors[i] = false
        setPhoneError(errors)
      }
      phone.current[i] = p.currentTarget.value
    }

    function redirect() {
      window.open(`/templates`, '_blank')
    }

    const normalizePhone = (val, prev) => {
      return /^[\d +]*$/g.test(val) ? val.substr(0, 25) : prev
    }

    const normalizeEmail = val => {
      return val.replace(/\s+/g, '')
    }

    const verifyPhone = i => cb => {
      if (isEmpty(phone.current[i]) || !/^[\d +]*$/g.test(phone.current[i])) {
        const errors = [...phoneError]
        errors[i] = true
        setPhoneError(errors)
      } else {
        if (cb && typeof cb === 'function') {
          if (!isSaving) {
            cb()
          }
        }
      }
    }

    return (
      <FieldArray
        name={'additionalGuests'}
        component={({ fields }: any) => (
          <>
            {fields.map((guest, index) => {
              return (
              <>
                {type === 'update' ? (
                  <GuestInfoUpdate
                    size={size}
                    disabled={disabled}
                    key={guest}
                    formKey={guest}
                    expanded={disabled}
                    guestLabel={`${t('reservation_person')} ${index + 1}`}
                    canCopy={true}
                    withBorder={true}
                    parseName={parseName}
                  />
                ) : (
                  <GuestInfoCreate
                    size={size}
                    key={guest}
                    disabled={disabled}
                    formKey={guest}
                    expanded={disabled}
                    guestLabel={`${t('reservation_person')} ${index + 1}`}
                    canCopy={true}
                    withBorder={true}
                    parseName={parseName}
                  />
                )}
                <StyledSection
                  size={size}
                  withBorder={fields.length - 1 !== index}
                >
                  <Flex row={true}>
                    <Flex style={{ width: '100%' }} column={true}>
                      <Flex alignStart style={{ width: '100%' }} row={true}>
                        <TextInput.ReduxField
                          size={size}
                          label={t('reservation_phone')}
                          disabled={disabled}
                          withPopoverIcon={disabled}
                          labelStyle={{display: 'flex',gap: '8px'}}
                          width={'100%'}
                          name={`${guest}.phone`}
                          normalize={normalizePhone}
                          onChange={setPhone(index)}
                          errorMsg={
                            phoneError[index]
                              ? t('reservation_dialing_number_parse_error')
                              : undefined
                          }
                          type={'text'}
                          isSmallReservation={true}
                          wrapperStyle={{ marginBottom: `${10 * size}px` }}
                          style={{
                            borderBottomRightRadius: 0,
                            borderTopRightRadius: 0,
                          }}
                        />
                        <Flex style={{ marginTop: `${34 * size}px` }}>
                          {type === 'update' ? (
                            <CallButtonUpdate
                              className={'reservation-form-call-phone-button'}
                              size={size}
                              index={index}
                              onClick={verifyPhone(index)}
                            />
                          ) : (
                            <CallButtonCreate
                              className={'reservation-form-call-phone-button'}
                              size={size}
                              index={index}
                              onClick={verifyPhone(index)}
                            />
                          )}
                        </Flex>
                        <Flex style={{ marginTop: `${34 * size}px` }}>
                          {type === 'update' ? (
                            <MessageSendButtonUpdate
                              className={'reservation-form-send-phone-button'}
                              size={size}
                              index={index}
                              onClick={verifyPhone(index)}
                            />
                          ) : (
                            <MessageSendButtonCreate
                              className={'reservation-form-send-phone-button'}
                              size={size}
                              index={index}
                              onClick={verifyPhone(index)}
                            />
                          )}
                        </Flex>
                      </Flex>
                      <VisibilityControlled field={'email'}>
                        <Flex alignStart style={{ width: '100%' }} row={true}>
                          <TextInput.ReduxField
                            label={t('email')}
                            withPopoverIcon={disabled}
                            labelStyle={{display: 'flex',gap: '8px'}}
                            size={size}
                            width={'100%'}
                            name={`${guest}.email`}
                            disabled={disabled}
                            normalize={normalizeEmail}
                            isSmallReservation={true}
                            style={{
                              borderBottomRightRadius: 0,
                              borderTopRightRadius: 0,
                            }}
                          />
                          <Flex style={{ marginTop: `${34 * size}px` }}>
                            {type === 'update' ? (
                              <TemplateSendButtonUpdate
                                className={'reservation-form-send-email-button'}
                                size={size}
                                index={index}
                                isSaving={isSaving}
                              />
                            ) : (
                              <TemplateSendButtonCreate
                                className={'reservation-form-send-email-button'}
                                size={size}
                                index={index}
                                isSaving={isSaving}
                              />
                            )}
                          </Flex>
                          <Flex
                            style={{ marginTop: `${34 * size}px` }}
                            alignEnd
                          >
                            <Button
                              onClick={redirect}
                              light
                              size={size}
                              style={{
                                borderRadius: 0,
                                height: `${38 * size}px`,
                              }}
                            >
                              <FiSettings />
                            </Button>
                          </Flex>
                        </Flex>
                      </VisibilityControlled>
                    </Flex>
                  </Flex>
                </StyledSection>
              </>
            )})}
          </>
        )}
      />
    )
  },
)

export interface IGuestsTabProps {
  initialValues: ICreateReservationFormValues
  isSaving?: boolean
  toggleTemplateSendModal: (
    toggle?: boolean,
    email?: string,
    event?: IEvent,
  ) => () => void
  type: string
  fieldVisibility: ReservationFormFieldVisibility
  isDesktop?: boolean
  event?: IEvent
  phoneError?: boolean
  guestScroll?: any
  allowTemplates?: boolean
  isLite?: boolean
  updateGuestName?: any
  hideUserData?: any
  firePricingError?: any
}

export { GuestsTab }

export default withIsDesktop(
  withTranslation()(
    withSize(
      connect(
        null,
        dispatch => ({
          updateGuestName: (form, name, val) =>
            dispatch(change(form, name, val)),
        }),
      )(GuestsTab),
    ),
  ),
)
